import type { Vendor } from "@shared/types";

/**
 * Kaffeesteuer (German coffee tax) only applies to the BDE region: a DE-home
 * roaster always carries it, while an NL-home roaster (provisioned under the
 * BDE region) only carries it when cross-border (shipTo includes more than
 * just its home country, i.e. it can ship to DE). BUS/BUK/BAU never qualify.
 */
export const shouldShowKaffeesteuer = (vendor: Vendor | undefined): boolean => {
  if (!vendor) return false;
  if (vendor.region !== "BDE") return false;
  if (vendor.countryCode === "DE") return true;
  return vendor.countryCode === "NL" && (vendor.properties?.shipTo?.length ?? 0) > 1;
};
